import { App, General } from "./constants";
import { deepFreeze } from "./dataManipulation";

export const EXCLUDE_IN_PROCESS_DOCUMENTS = Object.freeze({
  REQUERIMENTO: 6,
  CI: 1,
  CI_CIRCULAR: 4,
  FOLHA_DE_DESPACHO: 3,
  PARECER: 102
});

export const DOC_SIGNATURES_STATUS = Object.freeze({
  PENDING: "PENDING",
  SIGNED: "SIGNED",
  REFUSED: "REFUSED",
  PARTIALLY: "PARTIALLY",
  MANDATORY: "MANDATORY",
  VALIDATED: "VALIDATED",
  GIVE_KNOWLEDGE: "GIVE_KNOWLEDGE",
  NO_EFFECT: "NO_EFFECT",
  TO_PUBLISH_DOE: "TO_PUBLISH_DOE",
  AUTHORIZED_DOE: "AUTHORIZED_DOE",
  PROGRAMMED_DOE: "PROGRAMMED_DOE",
  PUBLISHED_DOE: "PUBLISHED_DOE",
  CHANGE_PROGRAM_DATE_DOE: "CHANGE_PROGRAM_DATE_DOE",
  REFUSED_DOE: "REFUSED_DOE",
  PROGRAM_CANCELED_DOE: "PROGRAM_CANCELED_DOE",
  REMOVE_TO_PUBLISH: "REMOVE_TO_PUBLISH_DOE",
  CHANGE_PUBLISH_DATE_DOE: "CHANGE_PUBLISH_DATE_DOE",
  REVERT_NO_EFFECT: "REVERT_NO_EFFECT"
});

export const GIVE_KNOWLEDGE_ERROR = Object.freeze({
  "Usuario nao possui e-mail cadastrado.": General.WITHOUT_USER_MAIL,
  "Necessario preencher o campo assunto.": General.WITHOUT_SUBJECT,
  "Necessario preencher o campo Para.": General.WITHOUT_TO,
  "Necessario preencher o campo Interessado.": General.WITHOUT_STAKEHOLDER,
  "Usuario nao possui acesso a essa acao.": General.WITHOUT_USER_ACCESS
});

export const CATEGORY_LEVEL = Object.freeze({
  "1": "CATEGORIA",
  "2": "SUBCATEGORIA 1",
  "3": "SUBCATEGORIA 2"
});

export const CATEGORY_CREATED = Object.freeze({
  "1": General.TEXTS.CREATED_CATEGORY,
  "2": General.TEXTS.CREATED_SUBCATEGORY,
  "3": General.TEXTS.CREATED_SUBCATEGORY_2
});

export const CATEGORY_UPDATED = Object.freeze({
  "1": General.TEXTS.UPDATED_CATEGORY,
  "2": General.TEXTS.UPDATED_SUBCATEGORY,
  "3": General.TEXTS.UPDATED_SUBCATEGORY_2
});

export const USER_NOTIFICATION_ID = Object.freeze({
  "1": {
    name: General.TEXTS.REFUSED_SUBSCRIPTION
  },
  "2": {
    name: General.TEXTS.PROCESS_CREATED
  },
  "3": {
    name: General.TEXTS.PROCESS_ARCHIVED
  },
  "4": {
    name: General.TEXTS.PROCESS_UNARCHIVED
  },
  "5": {
    name: General.SUBSCRIPTION_REQUEST
  },
  "6": {
    name: General.TEXTS.PROCESS_DISPATCHED
  },
  "7": {
    name: General.TEXTS.SIGNED_DOCUMENT
  },
  "8": {
    name: General.TEXTS.PROCESS_UNFAVORITED
  },
  "9": {
    name: General.TEXTS.SIGNATURE_CANCELED
  },
  "10": {
    name: General.TEXTS.KNOWLEDGE_GIVEN
  },
  "11": {
    name: General.TEXTS.DOCUMENT_JOIN
  },
  "12": {
    name: General.TEXTS.PROCESS_ASSIGNED
  },
  "13": {
    name: General.TEXTS.PROCESS_RETURNED
  },
  "14": {
    name: General.TEXTS.DOE_REFUSED_PUBLISH
  },
  "15": {
    name: General.TEXTS.DOE_PROGRAMMED_PUBLISH
  },
  "16": {
    name: General.TEXTS.DOE_CHANGED_PROGRAM_PUBLISH
  },
  "17": {
    name: General.TEXTS.DOE_PROGRAM_CANCELED
  },
  "18": {
    name: General.TEXTS.DOE_PUBLISH
  },
  "19": {
    name: General.TEXTS.INTERESTED_NOTIFICATION
  },
  "20": {
    name: General.TEXTS.AUTOMATIC_PROCESSING
  },
  "21": {
    name: General.TEXTS.AUTOMATIC_PROCESSING_CANCELLED
  },
  "22": {
    name: General.TEXTS.MIGRATE_PROCESS
  },
  "23": {
    name: General.TEXTS.OBLIGATORY_SIGNATURE_CHANGED
  }
});

export const SCREENS = Object.freeze({
  PROCESS_PANEL: "PROCESS_PANEL",
  PROCESS_DETAILS: "PROCESS_DETAILS"
});

export const DOE_PANEL_TABS = Object.freeze({
  AUTHORIZE: {
    value: "AUTHORIZE",
    name: App.DOEPanelScreen.AUTHORIZE
  },
  PROGRAMMED: {
    value: "PROGRAMMED",
    name: App.DOEPanelScreen.PROGRAMMED
  },
  REFUSED: {
    value: "REFUSED",
    name: App.DOEPanelScreen.REFUSED
  },
  PUBLICATED: {
    value: "PUBLICATED",
    name: App.DOEPanelScreen.PUBLICATED
  }
});

export const PROCESS_PANEL_TABS = Object.freeze({
  IN_ANALYSIS: {
    value: "IN_ANALYSIS",
    name: App.ProcessPainelScreen.IN_ANALYSIS
  },
  DRAFTS: {
    value: "DRAFTS",
    name: App.ProcessPainelScreen.IN_DRAFTS
  },
  FAVORITES: {
    value: "FAVORITES",
    name: App.ProcessPainelScreen.FAVORITES
  },
  SECTOR: {
    value: "SECTOR",
    name: App.ProcessPainelScreen.IN_SECTOR
  },
  PROCESSED: {
    value: "PROCESSED",
    name: App.ProcessPainelScreen.PROCESSED
  },
  ARCHIVED: {
    value: "ARCHIVED",
    name: App.ProcessPainelScreen.ARCHIVED
  }
});

export const PROCESS_DETAILS_TABS = Object.freeze({
  BASIC_DATA: {
    value: "BASIC_DATA",
    name: App.ProcessDetailsScreen.BASIC_DATA
  },
  ORDERS: {
    value: "ORDERS",
    name: App.ProcessDetailsScreen.ORDERS
  },
  DOCUMENTS: {
    value: "DOCUMENTS",
    name: General.DOCUMENTS
  },
  TIMELINE: {
    value: "TIMELINE",
    name: General.TIMELINE
  },
  MERGE_PROCESS: {
    value: "MERGE_PROCESS",
    name: General.MERGE_PROCESS
  },
  MERGE_DOCUMENTS: {
    value: "MERGE_DOCUMENTS",
    name: General.MERGE_DOCUMENTS
  },
  PENDING_DOCUMENTS: {
    value: "PENDING_DOCUMENTS",
    name: General.PENDING
  }
});

export const PROCESS_SIGNING_FILE_TABS = Object.freeze({
  SIGNING_REQUIRED: {
    value: "SIGNING_REQUIRED",
    name: General.TEXTS.MY_REQUIREMENT_SIGNING,
    bookmark: "bookmarks_received"
  },
  SIGNING_REQUESTED: {
    value: "SIGNING_REQUESTED",
    name: General.TEXTS.MY_SIGNING_REQUESTS,
    bookmark: "bookmarks_requested"
  },
  SIGNING_SIGNED: {
    value: "SIGNING_SIGNED",
    name: General.TEXTS.MY_SIGNED,
    bookmark: "bookmarks_answered"
  }
});

export const PROCESS_DETAILS_DOC_TABS = Object.freeze({
  PROCESS_DOCUMENTS: {
    value: "PROCESS_DOCUMENTS",
    name: General.PROCESS_DOCUMENTS
  },
  EDITABLE_DOCUMENTS: {
    value: "EDITABLE_DOCUMENTS",
    name: General.EDITABLE_DOCUMENTS
  }
});

export const PROCESS_STATUS = Object.freeze({
  PROCESSO_INICIAL: "Processo Inicial",
  DESPACHO: "Despacho"
});

export const TIMELINE_STATUS = Object.freeze({
  CRIACAO_RASCUNHO: "Criação do rascunho",
  ABERTURA_PROCESSO: "Abertura de Processo",
  ANEXO_ARQUIVO: "Anexo de arquivo",
  TRAMITACAO: "Tramitação",
  FILING: "Arquivamento",
  UNARCHIVING: "Desarquivamento",
  SUBSCRIPTION_REQUEST: "Solicitação de assinatura",
  REFUSAL_SIGN: "Recusa de assinatura",
  SIGNED: "Assinou"
});

export const PROCESS_SUBJECT_ICONS = Object.freeze({
  TIME: { icon: "clock-time-nine", color: "is-warning" },
  ATTENTION: { icon: "exclamation", color: "is-danger" },
  URGENT: { icon: "alert-circle", color: "is-danger" }
});

export const USER_PERMISSIONS = Object.freeze({
  SECTOR_VIEW: { id: 25 },
  ADD_RESPONSIBLE: { id: 26 },
  ARCHIVE_PROCESS: { id: 27 },
  UNARCHIVE_PROCESS: { id: 28 },
  ADM_VIEW: { id: 29 },
  PROCESS_PRIORITY: { id: 30 },
  PROCESS_SECRECY: { id: 31 },
  MANAGE_SUBJECT: { id: 33 },
  MANAGE_CATEGORY: { id: 34 },
  NO_EFFECT: { id: 35 },
  MANAGE_USER_ADM: { id: 37 },
  MANAGE_USER_PART: { id: 38 },
  MANAGE_USER_UNIT: { id: 39 },
  PROCESSOR: { id: 40 },
  PROTOCOLLER: { id: 41 },
  CREATE_PART_ADDRESS: { id: 43 },
  VALIDATE_ARCHIVE: { id: 51 },
  UNAPPEND_PROCESS: { id: 52 },
  VIEW_RESTRICT_PROCESS: { id: 53 },
  MANAGE_ADDRESS_ADM: { id: 54 },
  MANAGE_ADDRESS_PART: { id: 55 },
  MANAGE_ADDRESS_CAPACITY: { id: 56 },
  MANAGE_DOC_MODEL_ADM: { id: 57 },
  MANAGE_DOC_MODEL_PART: { id: 58 },
  MANAGE_DOC_MODEL_UNIT: { id: 59 },
  PUBLISH_DOE: { id: 60 },
  MANAGE_UNITY: { id: 61 },
  AUTHORIZE_DOE: { id: 62 },
  MANAGE_DOE: { id: 63 },
  MANAGE_DOE_DOC_MODEL_ADM: { id: 65 },
  MANAGE_DOE_DOC_MODEL_PART: { id: 66 },
  MANAGE_DOE_DOC_MODEL_UNIT: { id: 67 },
  MANAGE_BOOKMARKS_ADM: { id: 68 },
  MANAGE_BOOKMARKS_PART: { id: 69 },
  MANAGE_BOOKMARKS_CAPACITY: { id: 70 },
  MIGRATE_PROCESS_ADM: { id: 71 },
  MIGRATE_PROCESS_SECTOR: { id: 72 },
  VIEW_SECTOR_AND_CELLS: { id: 73 },
  MANAGE_PERMISSIONS: { id: 74 },
  MANAGE_PROFILES: { id: 75 },
  MANAGE_REPORT_ADM: { id: 76 },
  MANAGE_REPORT_PART: { id: 77 },
  MANAGE_REPORT_UNIT: { id: 78 },
  INTERNAL_CONTROL: { id: 79 },
  FORWARD: { id: 80 },
  MANAGE_MESSAGES_ADM: { id: 81 },
  VIEW_CONFIDENTIAL_PROCESS: { id: 82 },
  ADD_CONFIDENTIAL_RESPONSIBLE: { id: 83 },
  CREATE_LEGAL_REFERENCE: { id: 86 },
  SEE_PROCESS_SIZE: { id: 88 }
});

export const DOE_TYPES = Object.freeze({
  ACTS: "Atos",
  ALERT: "Avisos",
  NOTICES: "Editais",
  EXTRACTS: "Extratos"
});

export const NATURE_TYPES = Object.freeze({
  DIRECT_ADMINISTRATION: "Administração Direta",
  AUTARCHY: "Autarquia",
  MIXED_ECONOMY_SOCIETY: "Economia Mista",
  PUBLIC_COMPANY: "Empresa Pública",
  FOUNDATION: "Fundação"
});

export const DASHBOARD_VIEW_TYPES = Object.freeze({
  INDIVIDUAL: "INDIVIDUAL",
  SECTOR: "SECTOR",
  SECTOR_AND_SUBORDINATES: "SECTOR_AND_SUBORDINATES"
});

export const DOE_STATUS = Object.freeze({
  DOE_PUBLISHED: "DOE Publicado",
  DOE_AUTHORIZED: "DOE Autorizado",
  DOE_REFUSED: "DOE Recusado",
  DOE_PROGRAMMED: "DOE Programado",
  ABLE_TO_PUBLISH: "Apto a publicar DOE",
  MARKED_TO_PUBLISH: "Marcado para publicar DOE"
});

export const LIST_TYPE = Object.freeze({
  SIGN_INDIVIDUAL_FILE: "INDIVIDUAL",
  BATCH_SIGN_FILES: "BATCH"
});

export const USER_SEARCH_FILTERS = Object.freeze({
  CPF: "cpf",
  NAME: "name",
  PROFILES: "profiles",
  SUITE_ACCESS: "suite_access",
  PART: "part",
  CAPACITY: "capacity"
});

export const SEND_DOE_OPTIONS = Object.freeze({
  SENT: {
    name: "Enviado para o DOE",
    value: "Enviado para o DOE"
  },
  NOT_SENT: {
    name: "Não enviado para o DOE",
    value: "Não enviado para o DOE"
  }
});

export const SELECT_STATUS_OPTIONS = Object.freeze({
  ACTIVE: General.ACTIVE,
  INACTIVE: General.INACTIVE
});

export const ASSIGNER_PROFILES_OPTIONS = Object.freeze({
  PART_ADM: {
    name: App.ProfilesScreen.ASSIGNER_PROFILES.PART_ADM,
    id: 18
  },
  CAPACITY_ADM: {
    name: App.ProfilesScreen.ASSIGNER_PROFILES.CAPACITY_ADM,
    id: 3
  }
});

export const CONFIGURATION_UNITY_OPTIONS = Object.freeze({
  EXTERNAL_RECEPTOR: {
    name: App.ManageUnityFilter.CONFIGURATION.EXTERNAL_RECEPTOR,
    value: "external_receptor"
  },
  EXTERNAL_TRAMIT: {
    name: App.ManageUnityFilter.CONFIGURATION.EXTERNAL_TRAMIT,
    value: "external_tramit"
  },
  INTERNAL_RECEPTOR: {
    name: App.ManageUnityFilter.CONFIGURATION.INTERNAL_RECEPTOR,
    value: "internal_receptor"
  },
  INTERNAL_TRAMIT: {
    name: App.ManageUnityFilter.CONFIGURATION.INTERNAL_TRAMIT,
    value: "internal_tramit"
  },
  CORE_PROTOCOL: {
    name: App.ManageUnityFilter.CONFIGURATION.CORE_PROTOCOL,
    value: "core_protocol"
  }
});

export const STATUS_UNITY_OPTIONS = Object.freeze({
  ACTIVE: {
    name: App.ManageUnityFilter.STATUS.ACTIVE,
    value: true
  },
  INACTIVE: {
    name: App.ManageUnityFilter.STATUS.INACTIVE,
    value: false
  }
});

export const SIZES = Object.freeze({
  IS_SMALL: "is-small",
  IS_MEDIUM: "is-medium",
  IS_LARGE: "is-large"
});

export const DOCUMENT_TYPE = Object.freeze({
  CI: 1,
  OFFICIO: 2,
  CI_CIRCULAR: 4,
  OFFICIO_CIRCULAR: 5,
  REQUIREMENT: 6,
  ATTACHMENT: 7
});

export const PENDENCY_REASONS = Object.freeze({
  UNREADABLE_DOCUMENT: "Documento Ilegível",
  INCORRECT_DOCUMENT: "Documento Incorreto"
});

export const PENDENCY_STATUS = Object.freeze({
  PENDING: "Pendência Pendente",
  CANCELED: "Pendência Cancelada",
  ANSWERED: "Pendência Respondida"
});

export const DOCUMENT_DOE_STATUS_FILTER = Object.freeze({
  TO_PUBLISH: {
    name: "Publicar DOE",
    value: "TO_PUBLISH"
  },
  AUTHORIZED: {
    name: "DOE Autorizado",
    value: "AUTHORIZED"
  },
  PROGRAMMED: {
    name: "DOE programado",
    value: "PROGRAMMED"
  },
  REFUSED: {
    name: "DOE recusado",
    value: "REFUSED"
  },
  PUBLISHED: {
    name: "DOE publicado",
    value: "PUBLISHED"
  }
});

export const STAKEHOLDER_TYPES = Object.freeze({
  CAPACITY: "Lotação",
  LEGAL_ENTITY: "P. Jurídica",
  NATURAL_PERSON: "P. Física"
});

export const DASHBOARD_OPTIONS_TIME = Object.freeze({
  TODAY: "Hoje",
  WEEK: "Esta semana",
  MONTH: "Este mês",
  YEAR: "Este ano"
});

export const OFFICIAL_DOCUMENT_COVERAGE = Object.freeze({
  COMMON: "Comum",
  SPECIFIC: "Específico",
  NATURE: "Natureza"
});

export const PROCESS_FILES_MAX_SIZE = 838860800; //800 MB

export const MAX_SIGN_SIZE = 31457280; //30 MB

export const PRIORITY = deepFreeze([
  {
    id: 1,
    name: "Normal",
    level: 0,
    type: "NORMAL"
  },
  {
    id: 2,
    name: "Com contagem de prazo",
    level: 2,
    type: "TIME"
  },
  {
    id: 3,
    name: "Urgente",
    level: 1,
    type: "URGENT"
  }
]);

export const SECRECY_ID = deepFreeze({
  PUBLIC: 1,
  RESTRICTED: 2,
  CONFIDENTIAL: 3,
  SECRET_CONFIDENTIAL: 4,
  TOP_SECRET_CONFIDENTIAL: 5
});

export const SECRECY = deepFreeze([
  {
    id: 1,
    name: "Público",
    selectable: false
  },
  {
    id: 2,
    name: "Restrito",
    selectable: true
  },
  {
    id: 6,
    name: "Sigilo Legal",
    selectable: true
  },
  {
    id: 3,
    name: "Sigiloso - Reservado",
    period: 5,
    selectable: true
  },
  {
    id: 4,
    name: "Sigiloso - Secreto",
    period: 15,
    selectable: true
  },
  {
    id: 5,
    name: "Sigiloso - Ultrassecreto",
    period: 25,
    selectable: true
  }
]);

export const CONFIDENTIAL_SECRECY_IDS = deepFreeze([3, 4, 5, 6]);

export const PROCESS_DATE_TYPE = Object.freeze({
  IN_ANALYSIS: "user_responsible_date",
  FAVORITES: "last_tramited_date_es",
  PROCESSED: "last_tramited_date_es",
  ARCHIVED: "archived_date",
  SECTOR: "last_tramited_date_es"
});

export const DOE_TYPE_ACTIONS = Object.freeze({
  PROGRAM: "PROGRAM",
  CANCEL_PROGRAM: "CANCEL_PROGRAM",
  REFUSE: "REFUSE",
  PUBLISH: "PUBLISH"
});

export const UNIFIED_FILTER_OPTIONS = Object.freeze({
  ORIGIN: { name: General.REGISTRATION_ORGAN, type: "ORIGIN", key: "origin" },
  ORIGIN_CAPACITY: {
    name: General.ORIGIN_UNITY,
    type: "ORIGIN_CAPACITY",
    key: "origin_capacity"
  },
  CURRENT_CAPACITY: {
    name: General.CURRENT_CAPACITY,
    type: "CURRENT_CAPACITY",
    key: "current_capacity"
  },
  DATE: { name: General.PERIOD, type: "DATE", key: "date", unique: true },
  DATE_CREATED: {
    name: General.PERIOD_CREATED,
    type: "DATE_CREATED",
    key: "date_created",
    unique: true
  },
  CCS: {
    name: General.INTERESTED,
    type: "CCS",
    key: {
      CAPACITY: "capacities",
      USER: "users"
    }
  },
  DOCUMENT_TYPE: {
    name: General.TYPE_DOCUMENT,
    type: "DOCUMENT_TYPE",
    key: "document_type"
  },
  BOOKMARKS: { name: General.MARKERS, type: "BOOKMARKS", key: "bookmarks" },
  RESPONSIBLE: {
    name: General.RESPONSIBLE,
    type: "RESPONSIBLE",
    key: "responsible"
  },
  ANALYSIS: {
    name: General.STATUS,
    type: "ANALYSIS",
    key: "analysis",
    unique: true
  },
  STATUS_DOE: {
    name: General.PUBLICATION_DOE,
    type: "STATUS_DOE",
    key: "status_doe",
    unique: true
  },
  STATUS_SIGNATURE: {
    name: General.STATUS,
    type: "STATUS_SIGNATURE",
    key: "status_signature",
    unique: true
  },
  ORDER_BY_URGENT: {
    name: General.ORDER_TO,
    type: "ORDER_BY_URGENT",
    key: "order_by_urgent",
    unique: true
  },
  DOE_ORIGIN: {
    name: "Órgão de origem",
    type: "DOE_ORIGIN",
    key: "origin"
  },
  DOE_DATE: {
    name: General.PERIOD,
    type: "DOE_DATE",
    key: "date",
    unique: true
  },
  DOE_DATE_PROGRAMMED: {
    name: General.PERIOD_PROGRAMATION,
    type: "DOE_DATE_PROGRAMMED",
    key: "dateProgrammed",
    unique: true
  },
  DOE_SUBSCRIBER: {
    name: "Assinado por",
    type: "DOE_SUBSCRIBER",
    key: "subscriber"
  },
  DOE_SUBJECT: {
    name: "Assunto",
    type: "DOE_SUBJECT",
    key: "subject"
  },
  DOE_SENT_DOE: {
    name: "Situação DOE",
    type: "DOE_SENT_DOE",
    key: "sentToPrintshop",
    unique: true
  }
});

export const PROCESS_PANEL_FILTER_OPTIONS = Object.freeze({
  ORIGIN: { name: General.REGISTRATION_ORGAN, type: "ORIGIN", key: "origin" },
  ORIGIN_CAPACITY: {
    name: General.ORIGIN_UNITY,
    type: "ORIGIN_CAPACITY",
    key: "origin_capacity"
  },
  CURRENT_CAPACITY: {
    name: General.CURRENT_CAPACITY,
    type: "CURRENT_CAPACITY",
    key: "current_capacity"
  },
  DATE: { name: General.PERIOD, type: "DATE", key: "date", unique: true },
  DATE_CREATED: {
    name: General.PERIOD_CREATED,
    type: "DATE_CREATED",
    key: "date_created",
    unique: true
  },
  CCS: {
    name: General.INTERESTED,
    type: "CCS",
    key: {
      CAPACITY: "capacities",
      USER: "users"
    }
  },
  DOCUMENT_TYPE: {
    name: General.TYPE_DOCUMENT,
    type: "DOCUMENT_TYPE",
    key: "document_type"
  },
  BOOKMARKS: { name: General.MARKERS, type: "BOOKMARKS", key: "bookmarks" },
  RESPONSIBLE: {
    name: General.RESPONSIBLE,
    type: "RESPONSIBLE",
    key: "responsible"
  },
  ANALYSIS: {
    name: General.STATUS,
    type: "ANALYSIS",
    key: "analysis",
    unique: true
  },
  STATUS_DOE: {
    name: General.PUBLICATION_DOE,
    type: "STATUS_DOE",
    key: "status_doe",
    unique: true
  },
  STATUS_SIGNATURE: {
    name: General.STATUS,
    type: "STATUS_SIGNATURE",
    key: "status_signature",
    unique: true
  },
  ORDER_BY_URGENT: {
    name: General.ORDER_TO,
    type: "ORDER_BY_URGENT",
    key: "order_by_urgent",
    unique: true
  }
});

export const PROCESS_DOCUMENT_FILTER_OPTIONS = Object.freeze({
  ORIGIN_PART: {
    name: General.ADDED_BY_PART,
    type: "ORIGIN_PART",
    key: "origin",
    showIn: ["EDITABLE_DOCUMENTS", "PROCESS_DOCUMENTS"]
  },
  ORIGIN_CAPACITY: {
    name: General.ADDED_ON_UNITY,
    type: "ORIGIN_CAPACITY",
    key: "origin_capacity",
    showIn: ["EDITABLE_DOCUMENTS", "PROCESS_DOCUMENTS"]
  },
  USER_DOCUMENT: {
    name: General.ADDED_BY_USER,
    type: "USER_DOCUMENT",
    key: "user_document",
    showIn: ["EDITABLE_DOCUMENTS", "PROCESS_DOCUMENTS"]
  },
  DOCUMENT_TYPE: {
    name: General.DOCUMENT_TYPE,
    type: "DOCUMENT_TYPE",
    key: "document_type",
    showIn: ["EDITABLE_DOCUMENTS", "PROCESS_DOCUMENTS"]
  },
  STATUS_SIGNATURE: {
    name: General.STATUS,
    type: "STATUS_SIGNATURE",
    key: "status_signature",
    showIn: ["EDITABLE_DOCUMENTS", "PROCESS_DOCUMENTS"]
  },
  DOCUMENT_STATUS_DOE: {
    name: General.DOE_DOCUMENT,
    type: "DOCUMENT_STATUS_DOE",
    key: "document_status_doe",
    showIn: ["EDITABLE_DOCUMENTS", "PROCESS_DOCUMENTS"]
  },
  PROCESS_FILE_PAGE: {
    name: General.PROCESS_PAGE,
    type: "PROCESS_FILE_PAGE",
    key: "processfile_id",
    unique: true,
    showIn: ["PROCESS_DOCUMENTS"]
  }
});

export const DOE_FILTER_OPTIONS = Object.freeze({
  ORIGIN: {
    name: "Órgão de origem",
    type: "ORIGIN",
    key: "origin"
  },
  DATE: {
    name: General.PERIOD,
    type: "DATE",
    key: "date",
    unique: true
  },
  DATE_PROGRAMMED: {
    name: General.PERIOD_PROGRAMATION,
    type: "DATE_PROGRAMMED",
    key: "dateProgrammed",
    unique: true
  },
  SUBSCRIBER: {
    name: "Assinado por",
    type: "SUBSCRIBER",
    key: "subscriber"
  },
  SUBJECT: {
    name: "Assunto",
    type: "SUBJECT",
    key: "subject"
  },
  SENT_DOE: {
    name: "Situação DOE",
    type: "SENT_DOE",
    key: "sentToPrintshop",
    unique: true
  }
});

export const LOGIN_URL = "customer/login";

export const TAB_PERSIST_NAME = Object.freeze({
  PROCESS_IN_ANALYSIS: "PROCESS_IN_ANALYSIS",
  PROCESS_DRAFTS: "PROCESS_DRAFTS",
  PROCESS_FAVORITES: "PROCESS_FAVORITES",
  PROCESS_SECTOR: "PROCESS_SECTOR",
  PROCESS_PROCESSED: "PROCESS_PROCESSED",
  PROCESS_ARCHIVED: "PROCESS_ARCHIVED",
  SIGNING_REQUIRED: "SIGNING_REQUIRED",
  SIGNING_REQUESTED: "SIGNING_REQUESTED",
  SIGNING_SIGNED: "SIGNING_SIGNED",
  DOE_AUTHORIZE: "DOE_AUTHORIZE",
  DOE_PROGRAMMED: "DOE_PROGRAMMED",
  DOE_REFUSED: "DOE_REFUSED",
  DOE_PUBLICATED: "DOE_PUBLICATED",
  PROCESS_DETAIL_DOCUMENTS: "PROCESS_DETAIL_DOCUMENTS",
  SUBJECT_CATEGORIES: "SUBJECT_CATEGORIES",
  ADDRESS_LOGOS: "ADDRESS_LOGOS",
  ADM_BOOKMARKS: "ADM_BOOKMARKS",
  BOOKMARKS: "BOOKMARKS",
  DOCUMENT_MODELS: "DOCUMENT_MODELS",
  USERS: "USERS",
  MANAGE_UNITY: "MANAGE_UNITY",
  OFFICIAL_MODELS: "OFFICIAL_MODELS",
  MIGRATIONS: "MIGRATIONS",
  PERMISSIONS: "PERMISSIONS",
  PROFILES: "PROFILES",
  MESSAGES: "MESSAGES"
});

export const DOCUMENTS_ORDER_OPTIONS = Object.freeze({
  SEQUENCE_DOCUMENT: {
    name: "Número do documento (crescente)",
    value: "sequence",
    showIn: ["PROCESS_DOCUMENTS"]
  },
  SEQUENCE_DOCUMENT_DESC: {
    name: "Número do documento (decrescente)",
    value: "-sequence",
    showIn: ["PROCESS_DOCUMENTS"]
  },
  DATE: {
    name: "Mais recente - mais antigo",
    value: "-date",
    showIn: ["EDITABLE_DOCUMENTS", "PROCESS_DOCUMENTS"]
  },
  MINUS_DATE: {
    name: "Mais antigo - mais recente",
    value: "date",
    showIn: ["EDITABLE_DOCUMENTS", "PROCESS_DOCUMENTS"]
  },
  TYPE_DOCUMENT: {
    name: "Tipo de documento",
    value: "document_type__type",
    showIn: ["EDITABLE_DOCUMENTS", "PROCESS_DOCUMENTS"]
  }
});

export const BOOKMARK_MAX_NAME_SIZE = 20;
export const BOOKMARK_COLOR_SIZE = 7;

export const PROCESS_ORDER_OPTIONS = Object.freeze({
  URGENT: {
    name: App.DashboardScreen.URGENT_PROCESSED,
    value: true
  }
});
export const ATTACHEMENT_MAX_COUNT = 50;

export const EXTERNAL_SEARCH_OPTIONS = Object.freeze({
  SUITE: {
    name: "Suite",
    example: "(Ex: 00015.000636/2021-25)",
    description: "Número Único de Protocolo (NUP)",
    value: true
  },
  VIPROC: {
    name: "ViProc",
    example: "(Ex: 1234567/1998)",
    description: "Número/Ano",
    value: false
  }
});

export const MIGRATION_STATUS = Object.freeze({
  PENDING: "Pending",
  CANCELED: "Canceled",
  FINISHED: "Finished",
  ERROR: "Error",
  IN_PROGRESS: "In progress"
});

export const GUARDIAN_STATUS = Object.freeze({
  LOGIN_CREDENCIAL_INVALIDA: "is-warning",
  LOGIN_SISTEMA_INATIVO: "is-warning",
  LOGIN_VINCULO_NAO_ENCONTRADO: "is-warning",
  LOGIN_VINCULO_INATIVO: "is-warning",
  LOGIN_SENHA_EXPIRADA: "is-danger",
  LOGIN_EMAIL_NAO_PERMITIDO: "is-warning",
  LOGIN_EMAIL_NAO_ENCONTRADO: "is-warning",
  LOGIN_CODIGO_ENVIADO: "is-info",
  LOGIN_CODIGO_INVALIDO: "is-warning",
  LOGIN_APIKEY_INVALIDA: "is-warning",
  GENERIC_ERROR: "is-warning",
  RECUPERAR_SENHA_DADOS_INVALIDOS: "is-warning",
  RECUPERAR_SENHA_EMAIL_INVALIDO: "is-warning",
  RECUPERAR_SENHA_EMAIL_NAO_PERMITIDO: "is-warning",
  RECUPERAR_SENHA_EMAIL_NAO_ENCONTRADO: "is-warning",
  RECUPERAR_SENHA_CODIGO_ENVIADO: "is-info",
  ALTERAR_SENHA_DADOS_INVALIDOS: "is-warning",
  ALTERAR_SENHA_HASH_INVALIDO: "is-warning",
  ALTERAR_SENHA_SENHA_INVALIDA: "is-warning",
  ALTERAR_SENHA_CONFIRMACAO_DE_SENHA_INVALIDA: "is-warning",
  ALTERAR_SENHA_CODIGO_INVALIDO: "is-warning"
});

export const GUARDIAO = "guardiao";

export const NOTIFICATION_PDF_TITLE = "";

export const NOTIFICATION_NEW_VIEW_PDF = "";

export const PROCESS_DOWNLOAD_STATUS = Object.freeze({
  PENDING: "PENDING",
  STARTING: "GET_DOCUMENTS",
  MERGE: "JOIN_DOCUMENTS",
  FINISH: "FINISHING",
  CONCLUDED: "FINISHED",
  FAILED: "ERROR"
});

export const PROCESS_DOWNLOAD_STATUS_BACK = Object.freeze({
  GET_DOCUMENTS: "STARTING",
  JOIN_DOCUMENTS: "MERGE",
  FINISHING: "FINISH",
  FINISHED: "CONCLUDED",
  ERROR: "FAILED"
});

export const GIVE_KNOWLEDGE_PROCESS = "Dado ciência ao processo";

export const MINE_TYPE = Object.freeze({
  "89504e47": "image/png",
  "25504446": "application/pdf",
  ffd8ffe0: "image/jpeg",
  ffd8ffe1: "image/jpeg",
  ffd8ffe2: "image/jpeg",
  ffd8ffe3: "image/jpeg",
  ffd8ffe8: "image/jpeg",
  "504b0304": "application/zip",
  "47494638": "image/gif",
  "49492a00": "image/tiff",
  "4d4d002a": "image/tiff",
  "1f8b08": "application/gzip",
  "00018": "video/mp4",
  "00020": "video/mp4",
  "504b34": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  d0cf11e0: "application/vnd.ms-excel",
  "52617221": "application/x-rar-compressed",
  "3c3f786d": "application/xml",
  "7b5c7274": "application/rtf",
  "7f454c46": "application/x-elf"
});
